/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  DndContext,
  PointerSensor,
  closestCenter,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  SortableContext,
  arrayMove,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { canEditItemForItem, getId } from '../../utils/item';
import { update } from '../../services/item';
import { isTouchOnlyContext } from '../../utils/inputCapabilities';
import { isEditable } from '../../utils/roles';
import { ConditionSortable } from './condition.Sortable';

export const ConditionAll = props => {
  const { itemId } = props;
  const item = useSelector(state => state.items[itemId]);
  const items = useSelector(state => state.items);
  const isModalOpen = useSelector(state => state.global.openModales);
  const isMobile = useSelector(state => state.global.isMobile);
  const isTouch = useSelector(state => state.global.isTouch);
  const [conditions, setConditions] = useState(item?.conditions ?? []);
  const [shouldPersistOrder, setShouldPersistOrder] = useState(false);
  const canEdit = canEditItemForItem(item, items);
  const touchLocked = isTouchOnlyContext(isTouch);

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 5,
      },
    })
  );

  useEffect(() => {
    if (Array.isArray(item?.conditions)) {
      setConditions(item.conditions);
    } else {
      setConditions([]);
    }
    setShouldPersistOrder(false);
  }, [item?.conditions]);

  useEffect(() => {
    if (!shouldPersistOrder) {
      return;
    }
    if (
      Array.isArray(conditions) &&
      Array.isArray(item?.conditions) &&
      conditions.length === item.conditions.length &&
      JSON.stringify(conditions) !== JSON.stringify(item.conditions)
    ) {
      update(`items/${itemId}`, 'conditions', conditions).finally(() =>
        setShouldPersistOrder(false)
      );
    } else {
      setShouldPersistOrder(false);
    }
  }, [shouldPersistOrder, conditions, item?.conditions, itemId]);

  const handleDragEnd = event => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;
    setConditions(prev => {
      const oldIndex = prev.findIndex(cond => getId(cond) === active.id);
      const newIndex = prev.findIndex(cond => getId(cond) === over.id);
      return arrayMove(prev, oldIndex, newIndex);
    });
    setShouldPersistOrder(true);
  };

  if (!conditions?.length) {
    return (
      <div className='text-xs text-contrast text-opacity-50 p-1'>
        Aucun bouton pour le moment.
      </div>
    );
  }

  return (
    <div className='h-full w-full flex flex-col'>
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
      >
        <SortableContext
          items={conditions.map(conditionObj => getId(conditionObj))}
          strategy={verticalListSortingStrategy}
          disabled={
            isEditable() === false ||
            isEditable(Object.values(isModalOpen).includes(true)) ||
            isMobile ||
            touchLocked ||
            !canEdit
          }
        >
          <div className='w-full flex flex-col'>
            {conditions.map(conditionObj => (
              <ConditionSortable
                key={getId(conditionObj)}
                id={getId(conditionObj)}
                conditionId={getId(conditionObj)}
                itemId={itemId}
              />
            ))}
          </div>
        </SortableContext>
      </DndContext>
    </div>
  );
};
